import React, { useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import "./signin.css";

// import { Eye, EyeOff } from "lucide-react";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();


  //PASSWORD VIEW
const [showPassword, setShowPassword] = useState(false);


  const login = async () => {
    try {
      // Sign in the user
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      // Fetch the user's role from Firestore
      const userDoc = await getDoc(doc(db, "users", userId));
      if (userDoc.exists()) {
        const { role } = userDoc.data();

        // Navigate to the appropriate dashboard based on role
        if (role === "admin") {
          navigate("/superadminPanel");
        } else if (role === "corporate") {
          navigate("/corporate");
        }  else {
          alert("Role not recognized. Contact admin.");
        }
      } else {
        alert("No user data found. Please contact admin.");
      }
    } catch (error) {
      console.error("Error logging in:", error.message);
      alert(error.message);
    }
  };



  const navigateToForgotPassword = () => {
   
    navigate('/ForgotPassword');
  };

  return (

<div className="login-container">
      <div className="login-panel">
        <div className="left-panel">
          <h1 className="heading-login">Login Panel</h1>
          <input
            type="email"
            placeholder="Please Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type={showPassword ? "text" : "password"}  // Toggle input type based on showPassword state
            placeholder="Please Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          
          {/* <button
  type="button"
  onClick={() => setShowPassword(!showPassword)}
  style={{
    position: "absolute",
    top: window.innerWidth <= 360 ? "32%" : window.innerWidth <= 375 ? "31%" : window.innerWidth <= 441 ? "36%" :   window.innerWidth <= 480 ? "37%" : window.innerWidth <= 768 ? "38%" : "45%",
    right: window.innerWidth <= 480 ? "-150px" : window.innerWidth <= 768 ? "-130px" : "45px",
    transform: "translateY(-50%)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#aaa",
    transition: "color 0.3s",
    padding: "5px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}  
</button> */}


          {/* Forgot Password Link */}
          <div>
            <a 
              href="/ForgotPassword" 
              className="forgot-password-link"
              onClick={(e) => {
                e.preventDefault(); // Prevent default action if using JavaScript handling
                navigateToForgotPassword(); // Optional: Function to navigate programmatically
              }}
            >
              Forgot Password?
            </a>
          </div>

          <button onClick={login}>Login</button>
        </div>
        <div className="right-panel">
          <img src="logo.jpg" alt="Eye Care Institute Logo" className="logo" />
          <h2>Eye Care Student Attendance System</h2>
          <p>
        Welcome to the Eye Care Student Attendance System. This platform is designed to 
        efficiently manage and track student attendance records in a reliable and organized 
        manner. By streamlining the attendance process, it ensures accuracy, reduces 
        manual effort, and provides easy access to attendance data for both students 
        and administrators. 
        </p>
        </div>
      </div>
    </div>

  );
};

export default SignIn;
